import mushroom from "./api/dulich-api";
import config from "../config.json";
import { blockUi, unblockUi } from "../shared/global";
import LanguageService from "@/service/LanguageService";

window.requestCount = 0;

let ExtensionService = {};

ExtensionService.urlImg = config.hostApiDuLich + "api/dulich/v1/file/thumb?id=";
ExtensionService.urlSurveyImg = config.surveyPath + "file/thumb?id=";
ExtensionService.urlFile =
  config.hostApiDuLich + "api/dulich/v1/file/download?id=";
ExtensionService.urlFilesTemplate = {
  // DsKhachDuLich: "/files/template/DanhSachKhachDuLichMau.xlsx",
  DsKhachDuLich: "/DanhSachKhachDuLichMau.xlsx", // để vào public vì lại cần base url admin của du lịch mới tải được
  DsKDLMau: "/files/template/DanhSachKDLMau.xlsx",
  DsDDATMau: "/danhsach.xlsx",
  Hdsd: "/TaiLieuHDSDAPP.pptm",
  HdsdCsdvdl: "/TaiLieuHDSDWebCsdvdl.ppsx",
  // DsKhachDuLichMs:"files/template/DanhSachKhachDuLichMau.xlsx",
};
ExtensionService.urlSurveyFile = config.surveyPath + "file/download?id=";

ExtensionService.upload = (rawDataFile, tags) => {
  blockUi();
  return mushroom.$file
    .uploadAsync({
      file: rawDataFile.raw, // required
      name: rawDataFile.name, // optional
      tags: tags.split(","),
    })
    .then((response) => {
      unblockUi();
      return response;
    })
    .catch((error) => {
      unblockUi();
      toastr.error(LanguageService.lang.c_uploadError);
      throw error;
    });
};

export default ExtensionService;
